import React from 'react'
import { CityPolicy } from '../services/cityPolicyService'

interface CityPolicyCardProps {
  policy: CityPolicy | null
  allowanceCompensationDetails?: string | string[]
  refundDetails?: string | string[]
}

const CityPolicyCard: React.FC<CityPolicyCardProps> = ({ policy, allowanceCompensationDetails, refundDetails }) => {
  if (!policy) {
    return null
  }

  return (
    <div className="city-policy-card">
      <div className="policy-header">
        <div className="policy-icon">
          <i className="fas fa-coins"></i>
        </div>
        <h4 className="policy-title">补差计算详情</h4>
      </div>
      <div className="policy-content">
        <div className="details-content">
          {Array.isArray(allowanceCompensationDetails) ? (
            <div className="calculation-steps">
              {allowanceCompensationDetails.map((item, index) => {
                const content = String(item);
                const isFormula = content.includes('÷') || content.includes('×') || content.includes('=');
                const isResult = content.includes('MAX(') || content.includes('补差金额：');
                return (
                  <div key={index} className={`calculation-step ${isResult ? 'result-step' : ''}`}>
                    <div className="step-content">
                      {isFormula ? (
                        <div className="formula-content">
                          {content.split(/([÷×=])/).map((part, i) => (
                            <span key={i} className={/[÷×=]/.test(part) ? 'operator' : 'operand'}>
                              {part}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <div className="text-content">{content}</div>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <div>{allowanceCompensationDetails}</div>
          )}
        </div>
      </div>

      {refundDetails && (Array.isArray(refundDetails) ? refundDetails.length > 0 : refundDetails) && (
        <>
          <div className="policy-header" style={{ marginTop: '20px' }}>
            <div className="policy-icon">
              <i className="fas fa-calculator"></i>
            </div>
            <h4 className="policy-title">返还金额计算详情</h4>
          </div>
          <div className="policy-content">
            <div className="details-content">
              {Array.isArray(refundDetails) ? (
                <div className="calculation-steps">
                  {refundDetails.map((item, index) => {
                    const content = String(item);
                    const isFormula = content.includes('÷') || content.includes('×') || content.includes('=');
                    const isResult = content.includes('返还金额：') || content.includes('剩余：');
                    return (
                      <div key={index} className={`calculation-step ${isResult ? 'result-step' : ''}`}>
                        <div className="step-content">
                          {isFormula ? (
                            <div className="formula-content">
                              {content.split(/([÷×=\-+])/).map((part, i) => (
                                <span key={i} className={/[÷×=\-+]/.test(part) ? 'operator' : 'operand'}>
                                  {part}
                                </span>
                              ))}
                            </div>
                          ) : (
                            <div className="text-content">{content}</div>
                          )}
                        </div>
                      </div>
                    )
                  })}
                </div>
              ) : (
                <div>{refundDetails}</div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default CityPolicyCard
